import React from "react";
import CustomPicky from "./CustomPicky";

const ProjectsMultiSelect = ({
  currentPage,
  isShowingWorkers,
  projects,
  selectedProjectsObjects,
  onSelectProjects,
}) => {
  const isMulti = currentPage !== "Hours" && currentPage !== "Admin";
  const disablePages = currentPage === "Dashboard" || currentPage === "Hours";

  return (
    <CustomPicky
      key={`projects-${projects?.length || 0}-${currentPage}-${isShowingWorkers}`}
      className={
        disablePages && currentPage !== "Hours" && isShowingWorkers
          ? "picky_disabled"
          : ""
      }
      options={
        !isMulti && isShowingWorkers
          ? [{ label: "All projects", value: -1 }].concat(projects)
          : projects
      }
      value={
        isMulti && !Array.isArray(selectedProjectsObjects)
          ? [selectedProjectsObjects]
          : selectedProjectsObjects
      }
      multiple={isMulti}
      onChange={onSelectProjects}
      placeholder="Select project"
      disabled={disablePages && currentPage !== "Hours" && isShowingWorkers}
    />
  );
};

export default ProjectsMultiSelect;
